import axios from 'axios'
import merge from 'lodash.merge'


export const FormMixin = {
  template: '<div></div>',

  props: {
    action: {
      type: String,
      required: false
    },
    props: {
      type: Object,
      default() {
        return {
          data: {},
          errors: {},
        }
      }
    },
    errorMessages: {
      type: Object,
      default() { return {} }
    }
  },

  data() {
    return {
      data: this.props.data || {},
      // errors: this.props.errors || {},
      isValid: true,
      message: false,
      loading: false,
    }
  },

  watch: {
    'data': {
      handler(nval, oval) {
        if (!this.isValid) {
          this.validate()
        }
      },
      deep: true
    }
  },

  methods: {
    handleResponse(body) {
      this.loading = false

      if (body.message) {
        this.message = {
          status: body.status,
          code: body.code,
          message: body.message,
        }
      }
    },

    handleSuccess(response) {
      this.handleResponse(response.data)
      this.errors = {}

      this.$emit('submit-success', response)
    },

    handleError(error) {
      console.dir(error)
      if (
          typeof error.response == 'undefined' ||
          !error.response.data ||
          !error.response.data.status
      ) {
        this.handleResponse({
          code: 'error',
          message: error.message
        })

        this.$emit('submit-error', error)
        return
      }

      let data = error.response.data

      this.handleResponse(data)
      this.errors = data.errors

      this.$emit('submit-error', error)
    },

    getFormData() {
      let data = this.data
      let form = this.$refs.form
      if (typeof form != 'undefined') {
        data = new FormData(form)
      }

      return data
    },

    submit(event, method) {
      this.validate()

      if (!this.isValid) {
        return
      }

      let form = this.$refs.form
      let action = this.action
      let data = this.getFormData()

      if (typeof form != 'undefined') {
        if (typeof method == 'undefined') {
          method = this.$refs.form.getAttribute('method')
        }

        action = form.action
      }

      this.loading = true
      this.message = false
      this.errors = {}

      axios.request({
        method: method || 'post',
        url: action,
        data,
      })
        .then(r => this.handleSuccess(r))
        .catch(r => this.handleError(r))
    },

    validate() {
      this.isValid = Object.keys(this.data).reduce((acc, x) => {
        let method = `validate${x.toTitle()}`
        return acc && (
          typeof this[method] != 'undefined'
          ? this[method](this.data[x])
          : true
        )
      }, true)

      // HACK: Errors are not working properly. Dunno why.
      this.$set(this, 'errors', merge({}, this.errors))

      return this.isValid
    },

    clean() {
      this.data = this.props.data || {}
      this.errors = this.props.errors || {}
      this.message = false
      this.loading = false
      this.$emit('form-clean')
      this.$nextTick(x => {
        if (this.$refs.form) this.$refs.form.reset()
      })
    }
  }
}

export const CleanableFormMixin = {
  extends: FormMixin,

  mounted() {
    this.$on('submit-success', e => {
      this.clean()
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/mixins/forms.js